module.exports = __webpack_public_path__ + "img/banner.83d0f566.png";